import * as React from 'react';

import Dokanto4TwoSetNumber from '@/components/elements/Icon/Dokanto4TwoSetNumber';
import { EntryRacer } from '@/lib/apollo/types/gen/graphql';
import { makeCombination } from '@/lib/race';

import { Wrapper } from '../style';

interface RaceResultProps {
  entryRacers: EntryRacer[];
}

const RaceResult: React.FC<RaceResultProps> = React.memo(({ entryRacers }) => {
  const bicycleNums = entryRacers
    .filter(er => [1, 2].includes(er.arrivalOrder!))
    .map(er => er.bicycleNum);

  const resultMap = () => {
    if (bicycleNums.length > 2) {
      return makeCombination(bicycleNums, 2).map(nums => Number(nums.join('')));
    }
    return [Number(bicycleNums.join(''))];
  };

  // 1,2着の選手が2名以上存在しない場合
  if (bicycleNums.length < 2) {
    return <>不成立</>;
  }

  return (
    <Wrapper>
      {resultMap().map((num, i) => (
        <Dokanto4TwoSetNumber
          number={num}
          size={['18px', '24px', '32px', '32px']}
          key={`dokant4two-result-${i}`}
        />
      ))}
    </Wrapper>
  );
});

export default RaceResult;
